import SHEnumCombo from './src/combo.vue';

/* istanbul ignore next */
SHEnumCombo.install = function(Vue) {
  Vue.component('sh-enum-combo', SHEnumCombo);
};

export default SHEnumCombo;



// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/combo/index.js